export default "__VITE_ASSET__DacSPZ0B__";